// authSlice.js

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { handleContractorMasterListApiCall } from "../../../Api/api";

// Define an initial state for the slice
const initialState = {
   dataList: [],
   loading: false,
   error: null,
};

// Create an async thunk for the login action
export const listContractorMasterAsync = createAsyncThunk(
   "auth/contractor/contractor-list",
   async ({ done, err }, thunkAPI) => {
      try {
         const { data: response } = await handleContractorMasterListApiCall();
         if (response.statusCode === 200) {
            done && done();
            return thunkAPI.fulfillWithValue(response.res);
         } else {
            throw response;
         }
      } catch (error) {
         
         err && err(error.message);
         return thunkAPI.rejectWithValue(error);
      }
   }
);

// Create a slice of the Redux store
const contractorMasterListSlice = createSlice({
   name: "contractormasterlist",
   initialState,
   reducers: {
      // You can define additional synchronous actions here if needed
   },
   extraReducers: (builder) => {
      builder
         .addCase(listContractorMasterAsync.pending, (state) => {
            state.loading = true;
            state.error = null;
         })
         .addCase(listContractorMasterAsync.fulfilled, (state, action) => {
            state.loading = false;
            state.dataList = action.payload;
         })
         .addCase(listContractorMasterAsync.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload; // error message from the rejectWithValue call
         });
   },
});


// Export the reducer
export default contractorMasterListSlice.reducer;
